import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Drawer, Layout } from "antd";
import SidebarContent from "./SidebarContent";
import { updateWindowWidth } from "../../appRedux/actions/Setting";
import {
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  TAB_SIZE,
  THEME_TYPE_LITE
} from "../../constants/ThemeSetting";
import { TOGGLE_COLLAPSED_NAV } from "../../constants/ActionTypes";

const { Sider } = Layout;

const Sidebar = () => {
  const dispatch = useDispatch();
  const { themeType, navStyle } = useSelector(({ settings }) => settings);
  const { navCollapsed, width } = useSelector(({ common }) => common);
  
  const toggleCollapsedNav = (navCollapsed) => ({
    type: TOGGLE_COLLAPSED_NAV,
    navCollapsed,
  });

  useEffect(() => {
    let resizeTimeout;
    
    const handleResize = () => {
      const newWidth = window.innerWidth;
      
      clearTimeout(resizeTimeout);
      
      resizeTimeout = setTimeout(() => {
        dispatch(updateWindowWidth(newWidth));
      }, 100);
    };
    
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(resizeTimeout);
    };
  }, [dispatch]);

  const isMobile = width < TAB_SIZE;

  let drawerStyle = "gx-collapsed-sidebar";
  if (navStyle === NAV_STYLE_FIXED) {
    drawerStyle = "";
  } else if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
    drawerStyle = "gx-mini-sidebar gx-mini-custom-sidebar";
  } else if (navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) {
    drawerStyle = "gx-custom-sidebar"
  } else if (navStyle === NAV_STYLE_MINI_SIDEBAR) {
    drawerStyle = "gx-mini-sidebar";
  } else if (navStyle === NAV_STYLE_DRAWER) {
    drawerStyle = "gx-collapsed-sidebar"
  }
  
  if ((navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR
    || navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) && isMobile) {
    drawerStyle = "gx-collapsed-sidebar"
  }

  if (isMobile || navStyle === NAV_STYLE_DRAWER) {
    return (
      <Drawer
        className={`gx-drawer-sidebar ${themeType !== THEME_TYPE_LITE ? 'gx-drawer-sidebar-dark' : null}`}
        placement="left"
        closable={false}
        onClose={() => dispatch(toggleCollapsedNav(false))}
        open={navCollapsed}
        width={120}
        style={{ zIndex: 1000 }}
      >
        <SidebarContent />
      </Drawer>
    );
  }

  // Desktop view - show normal Sider
  return (
    <Sider
      className={`gx-app-sidebar ${drawerStyle} ${themeType !== THEME_TYPE_LITE ? 'gx-layout-sider-dark' : null}`}
      trigger={null}
      collapsed={false}
      theme={themeType === THEME_TYPE_LITE ? "lite" : "dark"}
      width={120}
      collapsedWidth={120}
      style={{ minWidth: '120px', maxWidth: '120px' }}
    >
      <SidebarContent />
    </Sider>
  );
};

export default Sidebar;